<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between align-items-center">
    @if (pageName) {
    <!-- Non-home: back arrow + page name -->
    <div class="d-flex align-items-center">
      <button class="back-btn" (click)="goBack()" attr.aria-label="{{ 'nav.back.screenreader' | translate }}">
        <span class="icon material-icons material-mobile-nav text-white">arrow_back_ios</span>
      </button>
      <span class="page-name fw-bold text-white text-uppercase" [class.page-name--centered]="!showHamburger">{{ pageName }}</span>
    </div>
    } @else {
    <!-- Home: logo -->
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo" [src]="(isClub1901 ? 'logos/logo-white.png' : 'logos/logo.svg') | contentAssetImage" draggable="false" />
    </a>
    }

    <div class="nav-item d-flex align-items-center">
      <!--Notifications: home only-->
      @if (!pageName) {
      <fgb-notification-button></fgb-notification-button>
      }

      <!--Wallet button: shown when showWalletButton input is true-->
      @if (showWalletButton) {
      <a class="wallet-btn d-flex align-items-center justify-content-center" [routerLink]="['/rewards/wallet']">
        <span class="icon material-icons text-black mb-0">qr_code</span>
      </a>
      }

      <!--Hamburger: hidden when showHamburger is false-->
      @if (showHamburger) {
      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        [ngClass]="{
          'rounded ms-3': isKid
        }"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
      }
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column h-100">
      <!-- Dropdown Header -->
      <div class="mobile-dropdown-header d-flex align-items-center justify-content-between px-2">
        <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
          <label id="homeLinkMenu" class="accessibility-only">Go To Home Page</label>
          <img alt="" class="home-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
        </a>

        <button
          attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
          class="btn p-2"
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="material-icons font-size-24 text-black">close</span>
        </button>
      </div>

      <!-- Nav Items -->
      <div class="p-4 d-flex flex-column gap-4 flex-grow-1 overflow-auto">
        <!-- Rewards -->
        <a class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black" [routerLink]="['/rewards']">
          <span class="material-icons text-black">redeem</span>
          <span class="fw-bold text-uppercase font-size-18">{{ 'nav.rewards' | translate }}</span>
        </a>

        <!-- Challenges -->
        <a
          class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black"
          [routerLink]="['/challenges']"
        >
          <span class="material-icons text-black">emoji_events</span>
          <span class="fw-bold text-uppercase font-size-18">{{ 'nav.challenges' | translate }}</span>
        </a>

        <!-- Training Zone (kids only) -->
        <ng-container *inPopulation="populations.Kids">
          <a
            class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black"
            [routerLink]="['/training-zone']"
          >
            <span class="material-symbols-outlined text-black">animated_images</span>
            <span class="fw-bold text-uppercase font-size-18">{{ 'nav.training.zone' | translate }}</span>
          </a>
        </ng-container>

        <!-- Exclusive Offers (non-kids, feature flagged) -->
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
          <ng-container *inPopulation="[populations.Default]">
            <a class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black" [routerLink]="['/brand']">
              <span class="material-symbols-outlined text-black">percent_discount</span>
              <span class="fw-bold text-uppercase font-size-18">{{ 'nav.offers' | translate }}</span>
            </a>
          </ng-container>
          <ng-container *inPopulation="[populations.Club1901]">
            <a class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black" [routerLink]="['/brand']">
              <span class="material-symbols-outlined text-black">percent_discount</span>
              <span class="fw-bold text-uppercase font-size-18">{{ 'nav.1901.offers' | translate }}</span>
            </a>
          </ng-container>
        </ng-container>

        <!-- Games -->
        <a class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black" [routerLink]="['/games']">
          <span class="material-icons text-black">sports_esports</span>
          <span class="fw-bold text-uppercase font-size-18">{{ 'nav.games' | translate }}</span>
        </a>

        <!-- Benefits (Default population only, external link) -->
        <ng-container *inPopulation="populations.Default">
          <a
            class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black"
            href="{{ 'nav.benefits.url' | translate }}"
            target="_blank"
          >
            <span class="material-icons text-black">loyalty</span>
            <span class="fw-bold text-uppercase font-size-18">{{ 'nav.benefits' | translate }}</span>
          </a>
        </ng-container>

        <!-- MyRewards (non-kids) -->
        <a
          *ngIf="!isKid"
          class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black"
          [routerLink]="['/rewards/wallet']"
        >
          <span class="material-icons text-black">account_balance_wallet</span>
          <span class="fw-bold text-uppercase font-size-18">{{ 'nav.wallet' | translate }}</span>
        </a>

        <!-- Latest -->
        <a class="mobile-menu-item d-flex align-items-center gap-3 text-decoration-none text-black" [routerLink]="['/tv']">
          <span class="material-symbols-outlined text-black">animated_images</span>
          <span class="fw-bold text-uppercase font-size-18">{{ 'nav.gallery' | translate }}</span>
        </a>

        <!-- Help -->
        <div>
          <button
            class="mobile-menu-item d-flex align-items-center justify-content-between w-100 btn p-0"
            (click)="helpExpanded = !helpExpanded"
          >
            <div class="d-flex align-items-center gap-3">
              <span class="material-icons text-black">info</span>
              <span class="fw-bold text-uppercase font-size-18 text-black">{{ 'nav.help' | translate }}</span>
            </div>
            <span class="material-icons text-black">{{ helpExpanded ? 'expand_less' : 'expand_more' }}</span>
          </button>
          <div *ngIf="helpExpanded" class="d-flex flex-column mobile-help-menu gap-3 pt-3">
            <a
              class="fw-bold text-decoration-none font-size-14 text-black"
              href="{{ 'nav.terms.url' | translate }}"
              target="_blank"
              >{{ 'nav.terms' | translate }}</a
            >
            <a
              class="fw-bold text-decoration-none font-size-14 text-black"
              href="{{ 'nav.faqs.url' | translate }}"
              target="_blank"
              >{{ 'nav.faq' | translate }}</a
            >
          </div>
        </div>
      </div>

      <!-- Logout -->
      <div class="p-4 pt-0">
        <button class="mobile-logout-btn d-flex align-items-center justify-content-center gap-2 w-100" (click)="logout()">
          <span class="material-icons text-danger">logout</span>
          <span class="fw-bold text-danger font-size-14">{{ 'nav.log.out' | translate : { fgbdefault: 'Log out' } }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
